@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.StatusDropDown {
  @extend %font-family-primary;

  color: $color-grey-B;
  position: relative;
  font-size: $font-size-normal;
  max-width: 250px;

  ul {
    padding: 0;
    list-style-type: none;
    max-height: 400px;
    overflow-y: scroll;
  }

  [role='listbox'] {
    margin: 0;
    max-width: 20em;
    padding: 0 0.5em;

    > li {
      padding: 1em;
    }
  }
}
